import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import { SalesOrderNotes } from "../models/orders/salesOrderNotes";

@Injectable({
  providedIn: "root",
})
export class OrderNotesGridService {
  private saleOrderManagementBaseURL =
    environment.baseUrl + "/SalesOrderManagement";
  constructor(private _http: HttpClient) {}

  getSalesOrderNotes(
    saleOrderId: string
  ): Observable<GenericResponseDto<SalesOrderNotes[]>> {
    return this._http.get<GenericResponseDto<SalesOrderNotes[]>>(
      this.saleOrderManagementBaseURL +
        `/GetSalesOrderNotes?SaleOrderId=` +
        saleOrderId
    );
  }
}
